<!-- Footer -->
<template>
  <footer class="section7">
    <div class="footer">
      <!-- <div class="footer_text"></div>
      <div class="info">
        <p @click="tuUrl('https://beian.miit.gov.cn/#/')" class="beian">{{ portalSet?.copyright }}</p>
        <div class="flex_div">
          <p>联系电话：{{ portalSet?.phone }}</p>
          <p @click="tuUrl('http://web.bjeaedu.com/yzAdmin/#/login')">管理登录</p>
        </div>
      </div> -->
      <div class="fo_top">
        <ul class="fo_nav">
          <li v-for="(item, index) in footerNav" :key="index">
            <h4 :class="{ on: isMobile && activeIndex === index, }" @click="handleTitleClick(index)" >
              {{ item.title }}
            </h4>
            <p :style="{ display:!isMobile || (isMobile && activeIndex === index) ? 'block' : 'none', }" v-for="(subItem, subIndex) in item?.stypesData?.list" :key="subIndex" >
              <span>
                <a @click="toUrl(subItem)">
                  {{ subItem.title }}
                </a>
              </span>
            </p>
          </li>
        </ul>
        <div class="fo_code">
          <img src="../images/erweima.png" alt="" />
          <p>关注官方微信公众号<br />北京亦庄实验中学</p>
        </div>
      </div>

      <div class="fo_co">
        <div class="fo_logo">
          <a><img src="../images/loginNew2.png" alt="" /></a>
        </div>
        <a href="https://beian.miit.gov.cn/#/" target="_blank">
          <p>{{portalSet?.copyright}}</p>
        </a>
        <div>
          <p>联系电话：{{ portalSet?.phone }}</p>
        </div>
        <div class="sydw_icon">
          <img src="../images/blue.png" alt="" @click="toSydwUrl()">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import portalApi from '../../../../lvya-common/src/api/eos/portal'
import { debounce } from '../../../../lvya-common/src/utils/DebounceThrottle.js'
import { mapState } from 'vuex'
import { useGetCategories } from '../utils/useGetCategories'

export default {
  props: {},
  components: {},
  data() {
    return {
      portalSet: null,
      portalSchoolInfo: '',
      info: '',
      section: [
        {
          title: '用户角色',
          list: [],
        },
        {
          title: '直通车',
          list: [
            { title: '云平台', path: '', target: '_blank' },
            { title: '校友卡申办', path: '', target: '_blank' },
            { title: 'FAQ', path: '', target: '_blank' },
            { title: '加入我们', path: '', target: '_blank' },
          ],
        },
        {
          title: '联系我们',
          list: [
            { title: '电话：010-88628801', path: '' },
            { title: '邮编：100039', path: '' },
            { title: '本部地址：北京市海淀区玉泉路66号', path: '' },
            { title: '北校区地址：北京市海淀区苏家坨镇环谷园路8号', path: '' },
          ],
        },
      ],
      activeIndex: undefined,
      pageWidth: 1080,
      footerNav: [],
    }
  },
  computed: {
    isShow() {
      return this.$route.path !== '/portalDetails'
    },
    ...mapState({
      roles: (state) => state.yzsyStore.roles,
    }),
    isMobile() {
      return this.pageWidth < 1023
    },
  },
  watch: {
    roles: {
      handler(val) {
        this.section[0].list = val
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取门户基础设置
    async getPortalSet() {
      // const portalSchoolInfo = JSON.parse(
      //   localStorage.getItem('portalSchoolInfo')
      // )
      let resData = await portalApi.getSet({
        noSchoolId: true,
        schoolId: '7',
      })
      console.log({ resData }, 'portal set')
      this.portalSet = resData
    },
    handleTitleClick(index) {
      if (this.activeIndex === index) {
        this.activeIndex = undefined
      } else {
        this.activeIndex = index
      }
      // if (this.pageWidth < 1023) {

      // } else {

      // }
      console.log(this.pageWidth, 'pageWidth')
    },
    async header() {
      const resData = await portalApi.getSetInfoBySid({
        id: '7',
      })
      this.info = resData
    },
    tuUrl(url) {
      window.open(url)
    },
    // 页脚导航数据
    async getNavList() {
      let res = { noSchoolId: true, schoolId: '7', id: '7', type: '3' }
      // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // if (userInfo) {
      //   res.roleTypes = userInfo.type
      // } else {
      //   res.roleTypes = '3'
      // }
      let resData = await portalApi.getNav(res)
      // console.log(resData, '000')
      this.footerNav = resData ? resData[0]?.stypes : []
      for (let val in this.footerNav) {
        this.footerNav[val].stypesData = await useGetCategories(this.footerNav[val].id)
      }
      // console.log(this.footerNav, '55555')
    },
    toUrl(data) {
      if (data.tzurl) {
        window.open(data.tzurl)
      }
    },
    toSydwUrl() {
      window.open('https://bszs.conac.cn/sitename?method=show&id=3A2F3C3D9B357307E06310291AAC2E33')
    },
  },
  created() {
    this.portalSchoolInfo = JSON.parse(
      localStorage.getItem('portalSchoolInfo')
    )
  },
  async mounted() {
    await this.getNavList()
    this.pageWidth = document.documentElement.clientWidth
    window.addEventListener(
      'resize',
      debounce((e) => {
        this.pageWidth = document.documentElement.clientWidth
      }, 50)
    )
    // this.header()
    this.getPortalSet()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {})
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.css";
.footer {
  padding: 0.2rem 0;

  .info {
    max-width: 14.8rem;
    margin: 0 auto;
    // overflow: hidden;
    // border-top: 1px solid #d9d9d9;
    position: relative;
    // height: 1.4rem;
    // padding: 1rem;
    p {
      text-align: center;
      font-size: 0.18rem;
      color: #888;
      margin: 0.15rem 0;
      // line-height: 1.4rem;
    }
    .beian{
      cursor: pointer;
    }
    .flex_div{
      display: flex;
      justify-content: center;
      p:nth-child(2) {
        color: blue;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .fo_co{
    position: relative;
    .sydw_icon{
      position: absolute;
      right: 0;
      top: 20px;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 640px) {
  .sydw_icon{
    position: relative !important;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    img{
      width: auto;
    }
  }
}
</style>
